/**
 * Pipeline stage.
 */
export enum PipelineStage {
  /** DepthOnly stage. */
  DepthOnly = "DepthOnly",
  /** Shadow caster stage. */
  ShadowCaster = "ShadowCaster",
  /** Forward shading stage. */
  Forward = "Forward"
}
